import { DetailsModal } from 'pages/account/account-orders/details-modal';

export default function AccountOrderDetail() {
  return <DetailsModal />;
}
